module.exports = __webpack_public_path__ + "media/images/bitmap/_main-image-d3716d2d6ec66bfde7c9d447814e4ee0.png";